<template>
  <div class="settings-container">
    <div class="header">
      <h2>设置</h2>
      <button class="back-btn" @click="goBack">返回</button>
    </div>

    <div class="settings-content">
      <!-- 1. 数据源选择 -->
      <div class="setting-section" v-if="false">
        <h3>数据源选择</h3>
        <div class="select-group">
          <select v-model="settings.market" class="market-select">
            <option value="futu">富途</option>
            <option value="sina">新浪</option>
          </select>
        </div>
      </div>

      <!-- 显示报警详情设置 -->
      <div class="setting-section">
        <h3>显示设置</h3>
        <div class="checkbox-group">
          <label class="checkbox-item">
            <input 
              type="checkbox" 
              v-model="settings.showAlertDetails"
            >
            显示报警详情
          </label>
        </div>
      </div>

      <!-- 3. 时间周期选择 -->
      <div class="setting-section">
        <h3>监控时间周期</h3>
        <div class="checkbox-group">
          <label v-for="period in timePeriods" :key="period.value" class="checkbox-item">
            <input 
              type="checkbox" 
              :value="period.value" 
              v-model="settings.selectedPeriods"
            >
            {{ period.label }}
          </label>
        </div>
      </div>

      <!-- 2. 报警项设置 -->
      <div class="setting-section">
        <h3>报警项设置</h3>
        <div v-for="period in settings.selectedPeriods" :key="period" class="period-section">
          <h4>{{ getTimePeriodLabel(period) }}数据报警项</h4>
          <div class="checkbox-group">
            <label v-for="alert in alertOptions" :key="`${period}-${alert.value}`" class="checkbox-item">
              <input 
                type="checkbox" 
                :value="alert.value" 
                v-model="settings.alerts[period]"
              >
              {{ alert.label }}
            </label>
          </div>
        </div>
      </div>

      <!-- 4. 打分系数设置 -->
      <div class="setting-section">
        <h3>打分系数设置</h3>
        <div class="coefficient-group">
          <div v-for="period in timePeriods" :key="`coeff-${period.value}`" class="coefficient-item">
            <label class="coefficient-label">{{ period.label }}系数：</label>
            <input 
              type="number" 
              v-model.number="settings.scoreCoefficients[period.value]" 
              class="coefficient-input"
              min="0"
              step="0.01"
            >
          </div>
        </div>
      </div>

      <!-- 5. 阈值设置 -->
      <div class="setting-section">
        <h3>阈值设置</h3>
        <div class="threshold-group">
          <div class="threshold-item">
            <label class="threshold-label">超卖：</label>
            <input 
              type="number" 
              v-model.number="settings.thresholds.oversold" 
              class="threshold-input"
              min="0"
              max="100"
            >
          </div>
          <div class="threshold-item">
            <label class="threshold-label">超买：</label>
            <input 
              type="number" 
              v-model.number="settings.thresholds.overbought" 
              class="threshold-input"
              min="0"
              max="100"
            >
          </div>
        </div>
      </div>

      <!-- 服务端监控列表 -->
      <div class="setting-section">
        <h3>服务端监控列表</h3>
        <div class="server-monitor-section">
          <div class="json-editor-container">
            <label>监控股票列表 (JSON格式):</label>
            <textarea 
              v-model="serverMonitorList" 
              class="json-editor" 
              placeholder="从服务器获取的监控列表将显示在此处..."
              rows="10"
            ></textarea>
          </div>
          <div class="server-actions">
            <button class="load-btn" @click="loadServerMonitorList" :disabled="loadingServerList">
              {{ loadingServerList ? '加载中...' : '从服务器加载' }}
            </button>
            <button class="save-server-btn" @click="saveServerMonitorList" :disabled="savingServerList">
              {{ savingServerList ? '保存中...' : '保存到服务器' }}
            </button>
          </div>
        </div>
      </div>

      <!-- 账户操作 -->
      <div class="action-section">
        <div class="actions">
          <button class="save-btn" @click="saveSettings">保存设置</button>
        </div>
        <div class="account-actions">
          <button class="logout-btn" @click="logout">
            🚪 退出登录
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Settings',
  data() {
    return {
      // 时间周期选项
      timePeriods: [
        { value: '1', label: '1分钟' },
        { value: '5', label: '5分钟' },
        { value: '30', label: '30分钟' },
        { value: 'd', label: '日线' },
        { value: 'w', label: '周线' }
      ],
      
      // 报警项选项
      alertOptions: [
        { value: 'macdRed', label: 'MACD红柱' },
        { value: 'kdjGoldenCross', label: 'KDJ金叉' },
        { value: 'kdjDeathCross', label: 'KDJ死叉' },
        { value: 'td6', label: '6转'},
        { value: 'td7', label: '7转'},
        { value: 'td8', label: '8转'},
        { value: 'td9', label: '9转'},
        { value: 'kdjBullishDivergence', label: '底背'},
        { value: 'kdjBearishDivergence', label: '顶背'}
      ],
      
      // 设置数据
      settings: {
        market: 'futu', // 默认选择富途
        showAlertDetails: false, // 默认不显示报警详情
        selectedPeriods: ['5', '30', 'd'], // 默认选中5分钟、30分钟、日线
        alerts: {
          '1': [],
          '5': [],
          '30': [],
          'd': [],
          'w': []
        },
        tdSequentialSettings: {
          '1': '9',
          '5': '9',
          '30': '9',
          'd': '9',
          'w': '9'
        },
        scoreCoefficients: {
          '1': 1,
          '5': 1,
          '30': 1,
          'd': 1,
          'w': 1
        },
        thresholds: {
          oversold: 1,  // 超卖阈值
          overbought: 99 // 超买阈值
        }
      },
      
      // 服务端监控列表相关数据
      serverMonitorList: '',
      loadingServerList: false,
      savingServerList: false
    };
  },
  
  mounted() {
    this.loadSettings();
    // 页面初始化时自动加载服务端监控列表
    this.loadServerMonitorList();
  },
  
  methods: {
    // 获取时间周期的标签
    getTimePeriodLabel(value) {
      const period = this.timePeriods.find(p => p.value === value);
      return period ? period.label : value;
    },
    
    // 返回监控页面
    goBack() {
      this.$router.push('/monitor');
    },
    
    // 保存设置到localStorage
    saveSettings() {
      localStorage.setItem('stockMonitorSettings', JSON.stringify(this.settings));
      alert('设置已保存！');
      this.$router.push('/monitor');
    },
    
    // 从localStorage加载设置
    loadSettings() {
      const savedSettings = localStorage.getItem('stockMonitorSettings');
      if (savedSettings) {
        this.settings = {
          ...this.settings,
          ...JSON.parse(savedSettings)
        };
        
        // 确保所有时间周期都有对应的报警设置和神奇九转设置
        this.settings.selectedPeriods.forEach(period => {
          if (!this.settings.alerts[period]) {
            this.settings.alerts[period] = [];
          }
          if (!this.settings.tdSequentialSettings[period]) {
            this.settings.tdSequentialSettings[period] = '9';
          }
        });
        
        // 确保showAlertDetails属性存在，默认为false
        if (this.settings.showAlertDetails === undefined) {
          this.settings.showAlertDetails = false;
        }
      }
    },

    // 退出登录
    logout() {
      if (confirm('确定要退出登录吗？')) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('stockMonitorSettings');
        this.$router.push('/login');
      }
    },
    
    // 加载服务端监控列表
    async loadServerMonitorList() {
      this.loadingServerList = true;
      try {
        const response = await fetch('https://www.ohvisa.cn/server_config.php?action=read_30f_stocks');
        const responseData = await response.json();
        
        if (responseData.success) {
          // 将数据格式化为JSON字符串显示在文本框中
          this.serverMonitorList = JSON.stringify(responseData.data, null, 2);
          console.log('服务端监控列表加载成功:', responseData.data);
        } else {
          alert(`加载失败: ${responseData.error || '未知错误'}`);
        }
      } catch (error) {
        console.error('加载服务端监控列表时发生错误:', error);
        alert(`加载失败: ${error.message}`);
      } finally {
        this.loadingServerList = false;
      }
    },
    
    // 保存服务端监控列表
    async saveServerMonitorList() {
      this.savingServerList = true;
      try {
        // 验证JSON格式
        let jsonData;
        try {
          jsonData = JSON.parse(this.serverMonitorList);
        } catch (parseError) {
          alert(`JSON格式错误: ${parseError.message}`);
          return;
        }
        
        const response = await fetch('https://www.ohvisa.cn/server_config.php?action=save_30f_stocks', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(jsonData)
        });
        
        const responseData = await response.json();
        
        if (responseData.success) {
          alert('保存成功！');
        } else {
          alert(`保存失败: ${responseData.error || '未知错误'}`);
        }
      } catch (error) {
        console.error('保存服务端监控列表时发生错误:', error);
        alert(`保存失败: ${error.message}`);
      } finally {
        this.savingServerList = false;
      }
    }
  }
};
</script>

<style scoped>
.settings-container {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.back-btn {
  padding: 8px 16px;
  background-color: #f0f0f0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.back-btn:hover {
  background-color: #e0e0e0;
}

.setting-section {
  margin-bottom: 30px;
  padding: 20px;
  border: 1px solid #eee;
  border-radius: 8px;
}

.setting-section h3 {
  margin-top: 0;
  color: #333;
}

.select-group {
  margin-top: 10px;
}

.market-select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  background-color: white;
  min-width: 120px;
}

.checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
}

.coefficient-group {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 10px;
}

.coefficient-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 150px;
}

.coefficient-label {
  white-space: nowrap;
}

.coefficient-input {
  width: 80px;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
}

.threshold-group {
  display: flex;
  gap: 20px;
  margin-top: 10px;
}

.threshold-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 120px;
}

.threshold-label {
  white-space: nowrap;
}

.threshold-input {
  width: 80px;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
}

.period-section {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 6px;
}

.period-section h4 {
  margin-top: 0;
  color: #555;
}

.td-sequential-settings {
  margin-top: 10px;
  padding: 10px;
  background-color: #fff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.td-sequential-settings label {
  font-weight: bold;
}

.td-sequential-settings select {
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

/* 服务端监控列表样式 */
.server-monitor-section {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.json-editor-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.json-editor-container label {
  font-weight: bold;
  color: #333;
}

.json-editor {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: 'Monaco', 'Consolas', 'Courier New', monospace;
  font-size: 14px;
  line-height: 1.4;
  resize: vertical;
  min-height: 150px;
  box-sizing: border-box;
}

.json-editor:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.server-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.load-btn, .save-server-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.load-btn {
  background-color: #28a745;
  color: white;
}

.load-btn:hover:not(:disabled) {
  background-color: #218838;
}

.save-server-btn {
  background-color: #007bff;
  color: white;
}

.save-server-btn:hover:not(:disabled) {
  background-color: #0069d9;
}

.load-btn:disabled, .save-server-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.action-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.actions {
  flex: 1;
  text-align: center;
}

.save-btn {
  padding: 12px 30px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  box-shadow: 0 4px 6px rgba(40, 167, 69, 0.2);
}

.save-btn:hover {
  background-color: #359c6d;
  box-shadow: 0 6px 8px rgba(40, 167, 69, 0.3);
}

.account-actions {
  flex-shrink: 0;
}

.logout-btn {
  padding: 8px 16px;
  background-color: #f8f9fa;
  color: #6c757d;
  border: 1px solid #ced4da;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
}

.logout-btn:hover {
  background-color: #e9ecef;
  color: #495057;
  border-color: #adb5bd;
}
</style>